<nav class="wizard-stepper-card" [attr.aria-label]="ariaLabel">
  @if (showBack) {
    <button type="button" class="wizard-back" (click)="back.emit()" aria-label="Back">‹</button>
  }

  <ol class="wizard-stepper">
    @for (step of steps; track step.id; let i = $index; let last = $last) {
      <li class="wizard-step-item">
        <button type="button" class="wizard-step" [ngClass]="'wizard-step--' + step.status"
          [disabled]="!step.clickable && step.status !== 'current'"
          [attr.aria-current]="step.status === 'current' ? 'step' : null"
          (click)="onSelect(step)">
          <span class="wizard-step__icon" aria-hidden="true">
            @if (step.status === 'complete') {
              ✓
            } @else {
              {{ i + 1 }}
            }
          </span>
          <span class="wizard-step__label">{{ step.label }}</span>
          @if (step.status === 'complete') {
            <span class="visually-hidden">(completed)</span>
          }
        </button>
      </li>
      @if (!last) {
        <li class="wizard-step__connector" aria-hidden="true"></li>
      }
    }
  </ol>
</nav>
